<template>
    <img
        v-if="show === true"
        :src="imagePath"
        v-bind="$attrs"
        :tabindex="tabIndexEnabled ? 0 : false" />
</template>

<script>
    import { FALLBACK_AVATAR } from 'vue/FormConfig';

    export default {
        name: 'AvatarImage',

        inheritAttrs: false,

        props: {
            tabIndexEnabled: {
                type: Boolean,
                default() {
                    return true;
                },
            },
        },

        data() {
            return {
                imagePath: null,
                show: false,
            };
        },

        created() {
            const img = new Image();
            img.src = this.$attrs.src;

            img.onload = () => {
                this.imagePath = img.src;
                this.show = true;
            };
            img.onerror = () => {
                this.imagePath = FALLBACK_AVATAR;
                this.show = true;
            };
        },

        updated() {
            this.imagePath = this.$attrs.src;
        },
    };
</script>
